// Scroll spy for the section navigation (components/section-nav). Marks
// the link of the section the reader is in with aria-current="true": the
// last section whose top edge has passed the bottom of the sticky bar.
// Once the page is scrolled to the very end, the last section wins, so a
// short final section (e.g. the FAQ) can still become current.
// Progressive enhancement: without this script the links stay plain
// in-page anchors. Only same-page hash targets are tracked, a link to
// another page is left alone.
function initSectionNav(): void {
  document.querySelectorAll<HTMLElement>('[data-th-section-nav]').forEach((nav) => {
    const entries: { target: HTMLElement; link: HTMLAnchorElement }[] = [];
    nav.querySelectorAll<HTMLAnchorElement>('a[href*="#"]').forEach((link) => {
      const url = new URL(link.href, window.location.href);
      if (url.pathname !== window.location.pathname || url.hash.length < 2) {
        return;
      }
      const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (target) {
        entries.push({ target, link });
      }
    });
    if (entries.length === 0) {
      return;
    }

    const update = (): void => {
      const line = nav.getBoundingClientRect().bottom + 24;
      const atEnd = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      let current: HTMLAnchorElement | null = null;
      if (atEnd) {
        current = entries[entries.length - 1].link;
      } else {
        entries.forEach(({ target, link }) => {
          if (target.getBoundingClientRect().top <= line) {
            current = link;
          }
        });
      }
      entries.forEach(({ link }) => {
        if (link === current) {
          if (!link.hasAttribute('aria-current')) {
            link.setAttribute('aria-current', 'true');
            revealInList(link);
          }
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    // On narrow screens the list scrolls horizontally; keep the current
    // link fully visible without touching the vertical page scroll.
    const list = nav.querySelector<HTMLElement>('.th-section-nav__list');
    const revealInList = (link: HTMLAnchorElement): void => {
      if (!list || list.scrollWidth <= list.clientWidth) {
        return;
      }
      const listBox = list.getBoundingClientRect();
      const linkBox = link.getBoundingClientRect();
      if (linkBox.left < listBox.left) {
        list.scrollLeft -= listBox.left - linkBox.left;
      } else if (linkBox.right > listBox.right) {
        list.scrollLeft += linkBox.right - listBox.right;
      }
    };

    let scheduled = false;
    const schedule = (): void => {
      if (scheduled) {
        return;
      }
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        update();
      });
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  });
}
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initSectionNav) : initSectionNav();
